var _desc, _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Property 1=No.",
    width: 32,
    height: 32,
    transform: "translate(0.000000 4.000000)",
    fill: "currentColor",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 31C12 32.1 11.1 33 10 33C8.89 33 8 32.1 8 31C8 29.89 8.89 29 10 29C11.1 29 12 29.89 12 31Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 31C25 32.1 24.1 33 23 33C21.89 33 21 32.1 21 31C21 29.89 21.89 29 23 29C24.1 29 25 29.89 25 31Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.28 13L27.71 13L24.41 24.55C24.29 24.96 24.04 25.33 23.69 25.6C23.34 25.86 22.92 26 22.48 26L10.51 26C10.07 26 9.65 25.86 9.3 25.6C8.95 25.33 8.7 24.96 8.58 24.55L4.06 8.72C4 8.51 3.87 8.33 3.7 8.2C3.52 8.07 3.31 7.99 3.09 8L1 8",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.04bac513f6384e65a608175fd58a6cca.svg";
export { ForwardRef as ReactComponent };